<div class="footer">
  <span>
    <a href="https://www.instagram.com/cmdunamis/" target="_blank" rel="noopener noreferrer" class="mr-3">
      <img src="./../../assets/instagram.png" alt="Instagram" class="social-icon">
    </a>

    <a href="https://www.facebook.com/christian.missiondunamis.5" target="_blank" rel="noopener noreferrer">
      <img src="./../../assets/facebook.png" alt="Instagram" class="social-icon">
    </a>
  </span>
  <p>Christian Mission Dunamis - 2021</p>
</div>
